// Maps a full site locale (e.g. en_US, es_US, fr_CA) to its ISO base language tag
export function mapLocaleToLang(locale: string | null | undefined): string {
  switch (locale?.toLowerCase() ?? '') {
    case 'es_us':
      return 'es';
    case 'fr_ca':
    case 'fr_us':
      return 'fr';
    case 'en_us':
    case 'en_ca':
    default:
      return 'en';
  }
}

export interface LangParams {
  siteLocale: string;
  lang: string;
}

export interface LangQueryParams {
  siteId?: string;
  langId?: string;
  [key: string]: any;
}

/** Returns the next locale when the user toggles language. */
export function toggleSiteLocale(current: string): string {
  switch (current) {
    case 'en_US': return 'es_US';
    case 'es_US': return 'en_US';
    case 'en_CA': return 'fr_CA';
    case 'fr_CA': return 'en_CA';
    default: return current;
  }
}

/**
 * Derives the siteLocale (for localStorage) and ISO lang attribute value from
 * query params. Centralises the duplicated cacn_homedepot / langId branching
 * so each call site only handles its own platform-specific side effects.
 */
export function resolveLangParams(queryParams: LangQueryParams | null | undefined): LangParams {
  if (queryParams?.siteId?.toLowerCase() === 'cacn_homedepot') {
    const langId = queryParams?.langId;
    let siteLocale: string;
    if (langId === 'fr_CA') {
      siteLocale = 'fr_CA';
    } else if (langId === 'fr_US') {
      siteLocale = 'fr_US';
    } else if (langId === 'en_US') {
      siteLocale = 'en_US';
    } else {
      siteLocale = 'en_CA';
    }
    return { siteLocale, lang: mapLocaleToLang(siteLocale) };
  } else if (queryParams?.langId) {
    return { siteLocale: queryParams?.langId, lang: mapLocaleToLang(queryParams?.langId) };
  } else {
    return { siteLocale: 'en_US', lang: 'en' };
  }
}
